import type { GridRowId } from '@mui/x-data-grid';

export const AUTO_APPROVE_DISTANCE_THRESHOLD = 50;

interface EligibilityRow {
  id: GridRowId;
  distance?: number | null;
  unitNumberAmbiguity?: boolean;
}

export const selectAutoApprovable = <T extends EligibilityRow>(
  selected: ReadonlyArray<GridRowId>,
  rows: ReadonlyArray<T>,
): { eligibleIds: Array<GridRowId>; ambiguousIds: Array<GridRowId>; tooFarIds: Array<GridRowId> } => {
  const byId = new Map<GridRowId, T>(rows.map((row) => [row.id, row]));
  const eligibleIds: Array<GridRowId> = [];
  const ambiguousIds: Array<GridRowId> = [];
  const tooFarIds: Array<GridRowId> = [];
  selected.forEach((id) => {
    const row = byId.get(id);
    if (row === undefined) return;
    if (row.unitNumberAmbiguity) ambiguousIds.push(id);
    else if ((row.distance ?? 0) >= AUTO_APPROVE_DISTANCE_THRESHOLD) tooFarIds.push(id);
    else eligibleIds.push(id);
  });
  return { eligibleIds, ambiguousIds, tooFarIds };
};
